import { Alert } from "./../types/alert.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import axios from "./api";

export const getSamplingPointNames = (alert: Alert): Promise<any[]> => {
  return axios.get<any[]>(`parameteralert/${alert.id}`).then(responseHandlerDefault);
};

export const getParameterAlerts = (id: number): Promise<any[]> => {
  return axios.get<any[]>(`parameteralert/parameters/${id}`).then(responseHandlerDefault);
};
